import React from "react";
import { Link } from "react-router-dom";

import logoIury from "../imgs/iury.png";

export const Footer = () => {
  const now = new Date().getFullYear();
  return (
    <div className="footer">
      <footer>
        <Link to="https://iuryflores.com.br" target="_blank">
          Desenvolvido por Iury Flores
        </Link>
        <Link to="https://iuryflores.com.br" target="_blank">
          <img src={logoIury} alt="Logotipo IHF" />
        </Link>{" "}
        <div className="logo">
          © 2023 - {now} | Todos os direitos reservados - Gyn Distribuidora
        </div>
      </footer>
    </div>
  );
};
